const instructionsDataInitial = [
  {
    id: "sauce-noodles",
    name: "",
    steps: [
      { text: "In a nonstick pan, over medium heat, add the #oil#. Stir in the #minced garlic#, then the #red pepper flakes#, and continue stirring for a few minutes, until garlic is fragrant." },
      { text: "Stir in the #brown sugar#, #soy sauce#, and (if using) #gochujang#. Lower heat and continue to stir occationally." },
      { text: "Meanwhile, cook the #noodles# per their instructions. Once cooked, transfer the noodles directly to the pan with the sauce (it's okay if some noodle water gets into the pan)." },
      { text: "Transfer to a bowl to serve. Optionally top with *chopped scallions*, *tasted sesame seeds*, and *gochugaru*." } 
    ]
  }
]

function importAll(r) {
  return r.keys().map(r);
}

const allMedia = importAll(require.context('./media/instructions', true, /\.(png|jpe?g|gif|webp|mp4|mov|avi|webm|mkv|flv|wmv|m4v|mpeg|mpg|svg)$/));
  
const mediaBySection = allMedia.reduce((acc, path) => {
  const sectionId = path.split('_')[0].split('/').pop(); // Extract section id from path
  if (!acc[sectionId]) { acc[sectionId] = [] } // Initialize array if it doesn't exist
  acc[sectionId].push(path); // Add path to array
  return acc;
}, {});

export const instructions = instructionsDataInitial.map(section => {
  // if there's an array of media for the given section
  if (mediaBySection[section.id]) {
      // add media array
      return { ...section, media: mediaBySection[section.id] };
  } else {
      return section;
  }
})